"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.unflattenType = void 0;
const unflattenType = (input) => {
    const result = {};
    Object.entries(input).forEach(([key, value]) => {
        const keys = key.split('.');
        let nestedObj = result;
        for (let i = 0; i < keys.length - 1; i++) {
            const nestedKey = keys[i];
            if (!(nestedKey in nestedObj)) {
                nestedObj[nestedKey] = {};
            }
            nestedObj = nestedObj[nestedKey];
        }
        const finalKey = keys[keys.length - 1];
        nestedObj[finalKey] = value;
    });
    return result;
};
exports.unflattenType = unflattenType;
//# sourceMappingURL=unflattenType.js.map